module.exports = __webpack_public_path__ + "static/img/7.edd9722.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/2/zh/7.png
// module id = dxbM
// module chunks = 0